module.exports = __webpack_public_path__ + "static/media/qr_code.0a1f09ed.jpg";